/* [PATCH pomoc-fe v1] Vsebina pomoči — aplikacija Prodaja. [PATCH prodaja-meni-nastavitve v1] poti menija NASTAVITVE.
   [PATCH pomoc-fe v1b] dopolnjeno po reconu v8/v9 [PATCH pomoc-fe v1c] Ročni vnos po zaslonu; [PATCH pomoc-fe v1d] nov račun po zaslonu; (gumbi z ikonami, zavihki Nastavitev, Šifranti, Prenos, Pregled).
   Vir napisov: recon v1–v9 (15.10.2026) iz kode na testu; NACRT_pomoc_uporabnikom_v3_20261015 §B.
   Pravilo: samo napisi, ki obstajajo v kodi. Ob spremembi zaslona posodobi tudi to datoteko. */
import { Postopek, StranPomoci, Tezava } from '../tipi';

const POGLEDI_PRODAJE = ['rocni', 'ponudbe', 'narocila', 'dobavnice', 'cmr'];
const jeDokumenti = (pot: string, sp: URLSearchParams) => pot === '/dokumenti' && (sp.get('tip') || '').startsWith('izdani');

/* ======================= PRODAJNI TOK ======================= */

const P_NOV_RACUN: Postopek = {
  id: 'prodaja.nov-racun', naslov: 'Izdaja novega računa', za: 'vsi',
  koraki: [
    'V meniju **PRODAJNI TOK** klikni **Izdani računi**.',
    'Nad seznamom klikni **+ Račun** (ali **+ Avansni račun**).',
    'Pri **Kupec** klikni **Izberi kupca iz šifranta**. Če kupca še ni, klikni ikono osebe s plusom (**Nov kupec (FURS)**) ali **+ nov kupec**.',
    'Preveri **Datum dokumenta**, **Datum storitve / dobave**, **Rok plačila**, **Način plačila** in **Jezik dokumenta**. **Številko dokumenta** lahko pustiš prazno — dodeli se ob izdaji (naslednja prosta številka vrste).',
    'Po potrebi vpiši **Št. naročila kupca (neobvezno)**, **Datum naročila kupca** in **Besedilo nad postavkami (neobvezno)**.',
    'V **Postavke** vpiši **Naziv** (polje išče tudi po šifrantu artiklov) ter **Količina**, **Enota**, **Cena** in po potrebi **Pop. %**; pod vrstico so **Dodaten opis (neobvezno)**, **Vrsta** in **DDV** (čuvaj predlaga, ti odločiš). Novo vrstico dodaš s **+ Dodaj vrstico**, odstraniš jo z ikono koša.',
    'Če je DDV 0 % (oproščen promet ali DDV ni obračunan), izpolni **Razlog** in **Besedilo klavzule (s sklicem na člen)** — obvezno, izpiše se na računu.',
    'Po želji **Besedilo v nogi (neobvezno)**.',
    'Osnutek se sam shrani kmalu po zadnjem vnosu (davčni čuvaj ga ob shranjevanju preveri); desno vidiš predogled. Lahko klikneš **Shrani osnutek**; ko je osnutek shranjen, sta na voljo še **Predogled PDF** (PDF z žigom OSNUTEK) in **Izbriši**.',
    'Klikni **Izdaj** (gumb je aktiven šele, ko je izbran kupec). Okno pove, ali gre račun v računovodstvo takoj ali šele ob potrditvi; če **Davčni čuvaj opozarja**, opozorila preberi — potrdi z **Izdaj**.',
    'Če sistem izpiše napake, jih popravi in ponovno klikni **Izdaj**.',
  ],
};

const P_SEZNAM_IZDANIH: Postopek = {
  id: 'prodaja.seznam', naslov: 'Seznam izdanih računov', za: 'vsi',
  koraki: [
    'Zgoraj izbereš vrsto (**Vsi**, **Računi**, **Avansni računi**, **Dobropisi**) in stanje; iskanje je po številki in kupcu.',
    'Stolpci: **Tip**, **Številka**, **Kupec**, **Datum**, **Skupaj**, **Stanje**, **Čuvaj** (opozorila davčnega čuvaja).',
    'Klik na vrstico pokaže prilogo (PDF) desno; širino priloge spremeniš z vlečenjem delilnika. Dvoklik ali **Odpri** odpre dokument.',
    'Nepotrjen račun potrdiš z **Potrdi** v vrstici, vse naenkrat s **Potrdi vse**.',
    'Ikona **čarobne palice** odpre čarovnik nastavitev, ikona zobnika nastavitve izdaje.',
  ],
};

const P_NOV_KUPEC: Postopek = {
  id: 'prodaja.nov-kupec', naslov: 'Nov kupec', za: 'vsi',
  koraki: [
    'Na dokumentu ob **Kupec** klikni ikono osebe s plusom (**Nov kupec (FURS)**) ali **+ nov kupec**.',
    'Vpiši **Davčna številka** in klikni gumb za preverbo v FURS/VIES — sistem izpolni prazna polja.',
    'Preveri **Naziv**, **Naslov**, **Poštna št.**, **Kraj**, **Davčni zavezanec**, **Matična številka**, **SKD dejavnost**, **Identifikacijska (ID za DDV)**.',
    'Pri **TRR / IBAN** lahko dodaš račun iz registra AJPES (**Dodaj**) ali ga vpišeš ročno.',
    'Obstoječega partnerja poiščeš z ikono **Odpri šifrant partnerjev in izberi**; kupca zamenjaš ali odstraniš z ikonama ob njem.',
  ],
};

const P_POTRDI: Postopek = {
  id: 'prodaja.potrdi', naslov: 'Popravljanje in potrditev računa', za: 'vsi',
  koraki: [
    'Če je vklopljeno **Popravljanje računa** (Nastavitve → Ostalo, ureja računovodstvo), izdan račun dobi oznako **nepotrjen**: ni še v računovodstvu in ga lahko popravljaš do pošiljanja kupcu.',
    'Spremembe shrani z **Shrani**.',
    'Ko je račun dokončen, klikni **Potrdi** — gre v računovodsko obravnavo in ga ni več mogoče popravljati.',
    'V seznamu izdanih računov potrdiš posamezen račun z **Potrdi** v vrstici ali vse naenkrat s **Potrdi vse** (viden, ko obstajajo nepotrjeni).',
    '**Pošlji** nepotrjen račun pred pošiljanjem samodejno potrdi.',
    'Izdajatelj vsak delovni dan ob 8:00 dobi e-poštni opomnik za nepotrjene račune iz preteklih dni.',
  ],
};

const P_POSLJI: Postopek = {
  id: 'prodaja.poslji', naslov: 'Pošiljanje kupcu po e-pošti', za: 'vsi',
  koraki: [
    'Na izdanem dokumentu klikni **Pošlji**.',
    'Preveri **Prejemnik**, **Zadeva** in **Besedilo**; po želji označi **Pošlji kopijo tudi meni**.',
    'Klikni **Pošlji** — PDF gre kot priloga. Če gumb ni aktiven, manjka prejemnik ali pošiljanje e-pošte ni nastavljeno.',
    'Besedilo e-pošte kupcu nastaviš v **Nastavitve → Ročni vnos računa**.',
  ],
};

const P_DOBROPIS: Postopek = {
  id: 'prodaja.dobropis', naslov: 'Dobropis in storno', za: 'vsi',
  koraki: [
    'Odpri izdan račun. Pri nepotrjenem računu najprej klikni **Potrdi** — gumba Dobropis in Storno se prej ne pokažeta.',
    '**Dobropis** → v oknu vpiši **Za vračilo** po vrsticah → **Dobropis za izbrane vrstice**, ali **Dobropis za cel račun**.',
    '**Storno** izda dobropis za še nedobropisani del računa.',
    'Dobropis se odpre kot osnutek — preglej ga in klikni **Izdaj**.',
  ],
};

const P_AVANS: Postopek = {
  id: 'prodaja.avans', naslov: 'Avansni račun in poračun', za: 'vsi',
  koraki: [
    'Avans izdaš z **+ Avansni račun** na strani Izdani računi.',
    'Ko na računu izbereš kupca z odprtim avansom, se pokaže opozorilo z gumbom **Poračunaj**.',
    'V oknu avansov (**Številka**, **Datum**, **Osnova**, **DDV**, **Skupaj**) klikni **Poračunaj** — avans se doda v račun.',
    'V tabeli poračuna (**Znesek avansa**, **Ostanek za poračun**, **Poračunano (bruto)**) lahko vpišeš manjši znesek: to je delni poračun, preostanek ostane odprt za naslednji račun.',
    'Nepotrjenega avansa ni mogoče poračunati — najprej ga potrdi.',
  ],
};

const P_IZ_DOKUMENTA: Postopek = {
  id: 'prodaja.iz-dokumenta', naslov: 'Ponudba, predračun, naročilo → naslednji dokument', za: 'vsi',
  koraki: [
    'Nov dokument ustvariš z **+ Ponudba**, **+ Predračun** ali **+ Naročilo** nad seznamom.',
    'Izdano ponudbo označiš z **Sprejeta** ali **Zavrnjena**.',
    'Naslednji dokument ustvariš z gumbi **+ …**: ponudba → **+ Predračun**, **+ Naročilo**, **+ Račun**, **+ Avansni račun**; predračun → **+ Račun**, **+ Avansni račun**; naročilo → **+ Predračun**, **+ Avansni račun**, **+ Dobavnica**, **+ Račun**.',
    'Nastane osnutek — preglej ga in klikni **Izdaj**.',
    'Predračun: **Označi plačano** oziroma **Razveljavi plačilo**.',
    '**Prekliči** prekliče ponudbo, predračun, naročilo ali dobavnico.',
    'Pri naročilu tabela pokaže **Naročeno**, **Dobavljeno**, **Fakturirano** in **Preostanek**.',
  ],
};

const P_DOBAVNICA: Postopek = {
  id: 'prodaja.dobavnica', naslov: 'Dobavnica in CMR', za: 'vsi',
  koraki: [
    'Na izdanem računu klikni **+ Dobavnica**, ali jo ustvari iz naročila, ali z **+ Dobavnica** na strani Dobavnice.',
    'Na dobavnici lahko vpišeš naslov dostave (**Naziv**, **Naslov**, **Pošta**, **Kraj**, **Država**) in pakete; teže vrstic se izračunajo iz artiklov, če jih pustiš prazne.',
    'Izpis: **PDF brez cen** ali **PDF s cenami**.',
    'CMR ustvariš iz dobavnice ali z **+ CMR** (ko je CMR vklopljen).',
    'Dobavnica in CMR **ne gresta v knjigovodstvo** in ne v DDV evidenco — dobita samo zaporedno številko.',
  ],
};

const P_KOPIJA: Postopek = {
  id: 'prodaja.kopija', naslov: 'Kopija, PDF in brisanje osnutka', za: 'vsi',
  koraki: [
    '**Kopiraj** (ne pri dobropisu) ustvari nov osnutek z istimi podatki.',
    '**PDF** odpre PDF v novem zavihku za tisk ali prenos.',
    'Osnutek izbrišeš z **Izbriši** → potrditev »Izbrišem osnutek?«. Brisanja ni mogoče razveljaviti.',
  ],
};

const P_KNJIZBE_R: Postopek = {
  id: 'prodaja.knjizbe-r', naslov: 'Knjižbe in DDV na dokumentu', za: 'racunovodja',
  koraki: [
    'V postavkah računovodja vidi še **Konto** in **SM** (stroškovno mesto, izbira v šifrantu).',
    'Pod dokumentom so knjižbe (**Breme/Dobro**, **Konto**, **Naziv**, **Znesek**, **SM**) in DDV (**Vrsta**, **Stopnja**, **Osnova**, **DDV**, **Stolpec**).',
    '**V računovodstvu** odpre dokument v računovodski obdelavi.',
  ],
};

/* ======================= NASTAVITVE ======================= */

const P_ARTIKLI: Postopek = {
  id: 'prodaja.artikli', naslov: 'Artikli', za: 'vsi',
  koraki: [
    '**Na dokumentu:** ob vrstici postavke klikni ikono **Izberi v šifrantu artiklov** in izberi artikel — podatki se prenesejo v vrstico.',
    '**Šifrant artiklov:** meni **NASTAVITVE → Šifranti** → zavihek **Artikli**. Iščeš po šifri, nazivu ali EAN.',
    '**Nov artikel**: izpolni **Šifra**, **Naziv**, **Vrsta**, **Enota**, **Koda enote (e-SLOG)**, **Cena brez DDV**, **DDV %**, po potrebi **Skupina**, **EAN**; za dobavnico/CMR še **Neto/Bruto teža na enoto (kg)**, **Carinska tarifa (KN)**, **Država porekla** → **Shrani**.',
    'Več artiklov naenkrat: **Uvoz CSV / XLSX** → **Osveži predogled** → **Uvozi**.',
    '**Predlagaj iz preteklih računov**: sistem predlaga artikle (najpogostejši zapis, število računov, zadnja cena) → označi (**Vse** / **Nič**) → **Dodaj izbrane v šifrant**.',
    'Artikel urediš z ikono **Uredi**; ne brišeš ga, ampak ga **deaktiviraš**.',
  ],
};

const P_PARTNERJI: Postopek = {
  id: 'prodaja.partnerji', naslov: 'Partnerji (kupci)', za: 'vsi',
  koraki: [
    'Meni **NASTAVITVE → Šifranti** → zavihek **Partnerji**.',
    'Iščeš po imenu, davčni ali ID za DDV; partnerja odpreš z **Uredi**.',
    'Neaktiven partner je označen in se v izbirnikih dokumentov ne ponuja.',
    'Nov kupec: glej postopek »Nov kupec«.',
  ],
};

const P_SM_PROJEKTI: Postopek = {
  id: 'prodaja.sm-projekti', naslov: 'Stroškovna mesta in projekti', za: 'vsi',
  koraki: [
    'Zavihka **Stroškovna mesta** in **Projekti** v Šifrantih: **Šifra** in **Naziv**.',
    'Stranka šifrante SM in projektov samo vidi; ureja jih računovodstvo.',
  ],
};

const P_SIFRANTI_R: Postopek = {
  id: 'prodaja.sifranti-r', naslov: 'Kontni plan in opisi za konte', za: 'racunovodja',
  koraki: [
    '**Kontni plan**: **Koda**, **Naziv**, **Zahteva SM**, **Privzeti SM**, **Saldakonto**; nov konto → **Shrani**.',
    '**Opisi za konte** (zavihka **Prejeti** / **Izdani**): pravilo iz **Beseda**, **Konto (končni, ≥4 mesta)**, **Pravilo določa**, pri izdanih še **Vrsta prometa (DDV)**; **Partner (neobvezno — iz šifranta)** — s partnerjem pravilo velja le zanj.',
    'Ročno vneseno pravilo ima prednost pred učnimi vzorci.',
  ],
};

const P_CAROVNIK: Postopek = {
  id: 'prodaja.carovnik', naslov: 'Čarovnik nastavitev', za: 'vsi',
  koraki: [
    'Čarovnik odpreš z ikono **čarobne palice** na strani Izdani računi ali na dokumentu.',
    'Koraki: **Oblika dokumenta** → **Logotip, žig, podpis** → **Nastavitve ročnega vnosa** → **Številčenje**. Pri vsakem koraku klikni **Shrani**, preden greš naprej; na koncu **Končaj**.',
    'Čarovnik lahko zapreš in nadaljuješ kasneje.',
  ],
};

const P_NAST_ROCNI: Postopek = {
  id: 'prodaja.nast-rocni', naslov: 'Nastavitve → Ročni vnos računa', za: 'vsi',
  koraki: [
    'Meni **NASTAVITVE → Nastavitve** → zavihek **Ročni vnos računa** (Nastavitve ročnega vnosa).',
    '**Podjetje je davčni zavezanec (obračunava DDV)** in **Računovodja pregleda pred prenosom (izdan račun čaka potrditev v Dokumentih)** nastavlja računovodja; ostalo lahko urejaš sam.',
    'Polja: **Privzeti rok plačila (dni)**, **Kraj izdaje**, **IBAN za plačilo (prazno = iz profila)**, **Podpisnik**, **Stalno besedilo v nogi računa**, **Sodni register** in **Osnovni kapital** (ZGD-1 45. člen).',
    '**E-pošta kupcu — zadeva** (prazno = privzeta; žetoni {vrsta}, {stevilka}, {podjetje}, {kupec}, {znesek}, {datum}, {rok}) in **E-pošta kupcu — besedilo** (prazno = privzeto).',
    '**Izgled računa (predloga, logotip, žig, podpis)** — izbira predloge in slik za vse nove dokumente.',
    'Tabela številčnih vrst: **Tip**, **Leto**, **Format**, **Naslednja**, **Primer**.',
  ],
};

const P_NAST_DOBAVA: Postopek = {
  id: 'prodaja.nast-dobava', naslov: 'Nastavitve → Dobavnica / CMR', za: 'vsi',
  koraki: [
    '**CMR tovorni list v prodajnem toku** — ob vklopu se v meniju pokaže **CMR**.',
    '**Dobavnico privzeto tiskaj s cenami** — velja za PDF ob izdaji in pošiljanju.',
    '**Stolpci na dobavnici**: izbereš stolpce in njihov vrstni red (puščici **Višje** / **Nižje**) → **Shrani**.',
  ],
};

const P_NAST_R: Postopek = {
  id: 'prodaja.nast-r', naslov: 'Računovodske nastavitve (zavihki)', za: 'racunovodja',
  koraki: [
    '**Splošne nastavitve**: bizBox ePredal (poverilnice za **Uvoz iz ePredala**), **Blokada davčnega obdobja**, **Zaklep poslovnega leta**, **Številčenje partnerjev** (**Po davčni številki** / **Zaporedno**), **Uvoz novih partnerjev preko XML**, **Priloga PDF pri prenosih**.',
    '**Številčenje**: **Interna številka izdanih računov** (**Zaporedna** / **Originalna številka računa**), **Veza = interna številka**, predpone pred interno številko (**+ Dodaj predpono**).',
    '**Kontiranje**: konti za knjiženje DDV po stopnjah in vrstah, **Privzeti konto prihodkov (fallback)**.',
    '**OSS države**: države in konti za OSS.',
    '**Ostalo**: konto za plačilo prek plačnika, nastavitve Mini blagajne (VKR), **Popravljanje računa** (**Omogoči popravljanje izdanega računa do potrditve**), **Zbirni kupec (brez davčne)**.',
  ],
};

/* ======================= RAČUNOVODSTVO ======================= */

const P_OBDELAVA: Postopek = {
  id: 'prodaja.obdelava', naslov: 'Obdelava izdanega dokumenta', za: 'racunovodja',
  koraki: [
    'Meni **RAČUNOVODSTVO → Računovodska obdelava**. Seznam po letih, filtri in iskanje po partnerju, znesku, postavkah, kontih.',
    'Oznake v seznamu: **Potrjen**, **Plačano**, **NI V ŠIFRANTU** (kupca ni v šifrantu).',
    'V maski preveri številko in interno številko (klik za urejanje), tip dokumenta, kupca (**Klikni za izbiro / zamenjavo kupca**, podatke partnerja urediš v šifrantu), TRR in sklic.',
    'Postavke (**Naziv**, **Kol.**, **Cena**, **DDV**, **Vrednost**, **Konto**), **Datumi**, **Kontiranje** in **DDV Evidenca — KIR**.',
    'Devizni račun: valuta, znesek v valuti in datum tečaja → **Preračunaj v EUR**. Postavke izven DDV (obroki, prenos stanja): **+ ostalo (neobdavčeno)**.',
    'Spremembe shrani z **Shrani** (**Esc = Prekliči**), dokument potrdi z **Potrdi**. Potrditev se prekliče v oknu **Preklic potrditve**.',
    'Na prodajni dokument se vrneš z **Odpri v Prodaji**.',
  ],
};

const P_UVOZ: Postopek = {
  id: 'prodaja.uvoz', naslov: 'Uvoz računov (modri gumb Uvoz)', za: 'racunovodja',
  koraki: [
    'Klikni **Uvoz** (modri gumb desno zgoraj).',
    'V oknu **Uvoz računov** izberi datoteke — **PDF ali Word (.doc, .docx)**, lahko več naenkrat.',
    'Okno lahko zapreš — obdelava teče naprej v ozadju; napredek vidiš ob ponovnem kliku na **Uvoz**.',
    'Uvoženi dokumenti se pojavijo v seznamu za pregled in potrditev.',
  ],
};

const P_UVOZ_ESLOG: Postopek = {
  id: 'prodaja.uvoz-eslog', naslov: 'Uvoz e-računov (eSLOG)', za: 'racunovodja',
  koraki: [
    'Klikni **Uvoz e-računov (eSLOG)**.',
    'Izberi ZIP ali pare XML + PDF (lahko več naenkrat).',
    'Preglej predogled, nato uvozi.',
    'Kupci, ki niso v šifrantu, ostanejo za ročno ureditev (rumeni pas s predlogi).',
  ],
};

const P_UVOZ_XML: Postopek = {
  id: 'prodaja.uvoz-xml', naslov: 'Uvoz XML (VOD, KN-21) / Excel (Mini blagajna)', za: 'racunovodja',
  koraki: [
    'Klikni **Uvoz XML**.',
    'Izberi XML (VOD, KN-21) ali Excel datoteko iz Mini blagajne.',
    'Predogled pokaže, kateri dokumenti bodo potrjeni, kateri gredo v pregled in kateri ne bodo uvoženi.',
  ],
};

const P_EPREDAL: Postopek = {
  id: 'prodaja.epredal', naslov: 'Uvoz iz ePredala', za: 'racunovodja',
  koraki: [
    'Gumb **Uvoz iz ePredala** (če je prikazan) prevzame eRačune iz bizBox ePredala.',
    'Poverilnice (**Strežnik**, **Uporabniško ime**, **Geslo**, **Prevzemaj dokumente od**) so v **Nastavitve → Splošne nastavitve**.',
  ],
};

const P_RAZDELI: Postopek = {
  id: 'prodaja.razdeli', naslov: 'Razdeli, združi, veži', za: 'racunovodja',
  koraki: [
    '**Razdeli dokument**: ikona **Razdeli PDF na več računov** v maski.',
    '**Združi dokumente**: ko je dokument del drugega, ga združiš z ikono **Ta dokument je del drugega — združi ju v enega**.',
    '**+ Veži dobropis / avans** → okno **Veži dobropis / avans na račun**: izberi dokument, **Znesek pobota (€)** → **Poveži**.',
  ],
};

const P_NEDAVNI: Postopek = {
  id: 'prodaja.nedavni', naslov: 'Nedavni uvozi, razveljavitev, brisanje', za: 'racunovodja',
  koraki: [
    '**Nedavni uvozi** → **Nedavni uvozi šopov**: **Preštevilči** (nova začetna interna številka) ali **Razveljavi**.',
    'Če se pokaže **Razveljavitev je blokirana**, lahko dokumente **Označi kot neprenešeno** in **Poskusi znova**.',
    '**Brisanje dokumenta**: **Izbriši dokument** — dejanja ni mogoče razveljaviti.',
    'Okno **Davčna blokada zaostaja** ponudi zaklep obdobja: **Zakleni do vključno (MM.YYYY)**.',
  ],
};

const P_PRENOS: Postopek = {
  id: 'prodaja.prenos', naslov: 'Prenos v računovodski program', za: 'racunovodja',
  koraki: [
    'Meni **RAČUNOVODSTVO → Prenos**. Program (**Vasco (KN-21)** ali **Opal / Pantheon — VOD**) je iz Nastavitve → Računovodski program.',
    'Zavihek **Za prenos** pokaže dokumente, ki še niso preneseni; **Preneseno** tiste, ki že so.',
    'Iskanje zožiš z **Interna št. od**, **Datum od** in **Iskanje (št./partner)**.',
    'Po želji vključi vgradnjo PDF v XML (VOD: Sken, KN-21: Priloga).',
    'Označi dokumente in klikni **Prenesi izbrane**; oznake odstraniš z **Odznači izbrane**.',
  ],
};

/* ======================= pogoste težave ======================= */

const T_IZDAJ: Tezava = { vprasanje: 'Gumb »Izdaj« ni aktiven', odgovor: 'Ni izbranega kupca. Izberi ga pri **Kupec**.', za: 'vsi' };
const T_DOBROPIS: Tezava = { vprasanje: 'Ni gumba »Dobropis« ali »Storno«', odgovor: 'Račun še ni potrjen. Klikni **Potrdi**.', za: 'vsi' };
const T_NI_V_RAC: Tezava = { vprasanje: 'Račun ni v računovodstvu', odgovor: 'Račun je **nepotrjen**. Klikni **Potrdi** (ali **Pošlji**, ki ga potrdi samodejno).', za: 'vsi' };
const T_POSLJI: Tezava = { vprasanje: 'Gumb »Pošlji« ni aktiven', odgovor: 'Manjka **Prejemnik** ali pošiljanje e-pošte ni nastavljeno.', za: 'vsi' };
const T_CMR: Tezava = { vprasanje: 'Ne vidim menija CMR', odgovor: 'CMR vklopiš v **Nastavitve → Dobavnica / CMR**.', za: 'vsi' };
const T_KUPEC: Tezava = { vprasanje: '»Kupca ni v šifrantu«', odgovor: 'Izberi obstoječega kupca ali dodaj novega (**Nov kupec (FURS)**).', za: 'vsi' };
const T_AVANS: Tezava = { vprasanje: '»Poračunaj« ne dela', odgovor: 'Avansni račun še ni potrjen — najprej ga potrdi, nato ga lahko poračunaš.', za: 'vsi' };
const T_KLAVZULA: Tezava = { vprasanje: 'Račun z DDV 0 % se ne izda', odgovor: 'Izpolni **Razlog** in **Besedilo klavzule (s sklicem na člen)** — obvezno, izpiše se na računu.', za: 'vsi' };
const T_POTRDI_R: Tezava = { vprasanje: '»Potrditev ni mogoča«', odgovor: 'Sporočilo pove, kaj manjka (npr. vrsta DDV v vrstici ali napaka v glavi). Popravi in znova klikni **Potrdi**.', za: 'racunovodja' };
const T_RAZVELJAVI_R: Tezava = { vprasanje: 'Uvoza ni mogoče razveljaviti', odgovor: 'Ob **Razveljavitev je blokirana** dokumente **Označi kot neprenešeno** in **Poskusi znova**.', za: 'racunovodja' };

/* ======================= strani ======================= */

export const PRODAJA: StranPomoci[] = [
  {
    kljuc: 'prodaja.pregled', naslov: 'Pregled prodaje', za: 'vsi',
    ujema: (pot) => pot === '/prodaja-pregled',
    opis: 'Pregled prodajnih dokumentov z datumom, kupcem, zneski, stanjem in roki. Vir: vsi izdani računi (uvoz, nalaganje in Izdaja). Primerjavo izbereš: **isto obdobje lani**, **prejšnje obdobje** ali **brez primerjave**.',
    postopki: [P_NOV_RACUN, P_IZ_DOKUMENTA],
  },
  {
    kljuc: 'prodaja.ponudbe', naslov: 'Ponudbe / predračuni', za: 'vsi',
    ujema: (pot, sp) => jeDokumenti(pot, sp) && sp.get('pogled') === 'ponudbe',
    opis: 'Seznam ponudb in predračunov. Nov dokument ustvariš z **+ Ponudba** ali **+ Predračun**.',
    postopki: [P_IZ_DOKUMENTA, P_NOV_KUPEC, P_POSLJI],
  },
  {
    kljuc: 'prodaja.narocila', naslov: 'Naročila kupcev', za: 'vsi',
    ujema: (pot, sp) => jeDokumenti(pot, sp) && sp.get('pogled') === 'narocila',
    opis: 'Seznam naročil kupcev. Novo naročilo ustvariš z **+ Naročilo**.',
    postopki: [P_IZ_DOKUMENTA, P_DOBAVNICA],
  },
  {
    kljuc: 'prodaja.dobavnice', naslov: 'Dobavnice in CMR', za: 'vsi',
    ujema: (pot, sp) => jeDokumenti(pot, sp) && (sp.get('pogled') === 'dobavnice' || sp.get('pogled') === 'cmr'),
    opis: 'Dobavnice in CMR. Novo ustvariš z **+ Dobavnica** oziroma **+ CMR**, ali iz naročila / računa.',
    postopki: [P_DOBAVNICA, P_NAST_DOBAVA],
    tezave: [T_CMR],
  },
  {
    kljuc: 'prodaja.izdani', naslov: 'Izdani računi', za: 'vsi',
    ujema: (pot, sp) => jeDokumenti(pot, sp) && sp.get('pogled') === 'rocni',
    opis: 'Računi, avansni računi in dobropisi. Klik na vrstico pokaže prilogo desno, dvoklik odpre dokument.',
    postopki: [P_NOV_RACUN, P_SEZNAM_IZDANIH, P_POTRDI, P_AVANS, P_DOBROPIS, P_CAROVNIK],
    tezave: [T_NI_V_RAC, T_DOBROPIS],
  },
  {
    kljuc: 'prodaja.dokument', naslov: 'Prodajni dokument', za: 'vsi',
    ujema: (pot) => pot.startsWith('/izdaja/'),
    opis: 'Levo obrazec (kupec, datumi, postavke), desno predogled. Gumbi na vrhu so odvisni od vrste in stanja dokumenta.',
    postopki: [P_NOV_RACUN, P_NOV_KUPEC, P_ARTIKLI, P_POTRDI, P_POSLJI, P_DOBROPIS, P_AVANS, P_IZ_DOKUMENTA, P_DOBAVNICA, P_KOPIJA, P_KNJIZBE_R],
    tezave: [T_IZDAJ, T_KLAVZULA, T_DOBROPIS, T_NI_V_RAC, T_POSLJI, T_AVANS, T_KUPEC],
  },
  {
    kljuc: 'prodaja.sifranti', naslov: 'Šifranti', za: 'vsi',
    ujema: (pot) => pot === '/sifranti',
    opis: 'Partnerji (kupci), artikli in drugi šifranti podjetja.',
    postopki: [P_ARTIKLI, P_PARTNERJI, P_NOV_KUPEC, P_SM_PROJEKTI, P_SIFRANTI_R],
  },
  {
    kljuc: 'prodaja.nastavitve', naslov: 'Nastavitve Prodaje', za: 'vsi',
    ujema: (pot) => pot === '/nastavitve',
    opis: 'Nastavitve izdaje dokumentov. Stranka vidi zavihka **Ročni vnos računa** in **Dobavnica / CMR**.',
    postopki: [P_NAST_ROCNI, P_NAST_DOBAVA, P_CAROVNIK, P_NAST_R],
    tezave: [T_CMR],
  },
  {
    kljuc: 'prodaja.obdelava', naslov: 'Računovodska obdelava izdanih', za: 'racunovodja',
    ujema: (pot, sp) => jeDokumenti(pot, sp) && POGLEDI_PRODAJE.indexOf(sp.get('pogled') || '') < 0,
    opis: 'Računovodska obravnava izdanih dokumentov: interna številka, kontiranje in DDV evidenca (KIR). Zgoraj desno: **Nedavni uvozi**, **Uvoz XML**, **Uvoz e-računov (eSLOG)**, **Uvoz**.',
    postopki: [P_OBDELAVA, P_UVOZ, P_UVOZ_ESLOG, P_UVOZ_XML, P_EPREDAL, P_RAZDELI, P_NEDAVNI],
    tezave: [T_POTRDI_R, T_RAZVELJAVI_R],
  },
  {
    kljuc: 'prodaja.prenos', naslov: 'Prenos', za: 'racunovodja',
    ujema: (pot) => pot === '/prenosi',
    opis: 'Prenos izdanih dokumentov v računovodski program kot XML (VOD ali KN-21). Smer prenosa določa izbrana aplikacija.',
    postopki: [P_PRENOS],
  },
];
